import { InputAdornment } from '@mui/material';
import { translateUnitEnum_dynamic } from '@predium/i18n/client';
import { UnitsValue } from '@predium/utils';
import { memo } from 'react';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import { BuildingFilters } from '@/components/building-filters/BuildingFilters';
import { useBuildingFilters } from '@/components/building-filters/BuildingFiltersProvider';
import { BuildingFiltersSearchParams } from '@/components/building-filters/search-params';
import NumberField from '@/components/form/NumberField';

export type NumberInputsSearchParams = Extract<
  BuildingFiltersSearchParams,
  | 'minPrimaryEnergy'
  | 'maxPrimaryEnergy'
  | 'minCo2Emissions'
  | 'maxCo2Emissions'
  | 'minFinalEnergy'
  | 'maxFinalEnergy'
  | 'minStrandingYear'
  | 'maxStrandingYear'
>;

type Props<Key extends NumberInputsSearchParams> = {
  type: Key;
  isError?: boolean;
  unit?: UnitsValue;
};

const NumberFilterInput = memo(function NumberFilterInput<Key extends NumberInputsSearchParams>({
  type,
  isError,
  unit,
}: Props<Key>) {
  const { filters, setFilters } = useBuildingFilters();

  const value = filters[type];

  const filter = BuildingFilters.find((f) => f.key === type);

  return (
    <NumberField
      label={filter?.title}
      value={value}
      onValueChange={(values) => {
        setFilters((prev) => ({
          ...prev,
          [type]: values.floatValue ?? null,
        }));
      }}
      variant="outlined"
      size="small"
      allowDecimals={false}
      isError={isError}
      InputProps={{
        endAdornment: unit ? (
          <InputAdornment position="end">
            <PTypography variant="caption" color={'secondary'}>
              {translateUnitEnum_dynamic(unit)}{' '}
            </PTypography>
          </InputAdornment>
        ) : null,
      }}
    />
  );
});

export default NumberFilterInput;
